<template>
  <div id="profession-candidate">
    <h5
      id="profession-copy"
      class="title is-4 step-description has-text-centered"
    >
      I'm a professional specializing in the following function within an organization:
    </h5>
    <div class="columns is-tablet has-text-centered">
      <div class="column">
        <div class="columns is-mobile has-text-centered">
          <div class="column">
            <i
              class="button is-primary is-rounded fas fa-users fa-2x profession-icon"
              :class="active.name === 'HR/Talent Acquisition' ? '' : 'is-outlined'"
              @click="selectProfession('HR/Talent Acquisition')"
            />
            <p class="is-size-6 has-text-grey has-text-weight-bold">
              HR or Talent Acquisition
            </p>
          </div>
          <div class="column">
            <i
              class="button is-primary is-rounded fas fa-laptop fa-2x profession-icon"
              :class="active.name === 'Technology' ? '' : 'is-outlined'"
              @click="selectProfession('Technology')"
            />
            <p class="is-size-6 has-text-grey has-text-weight-bold">
              Technology
            </p>
          </div>
        </div>
      </div>
      <div class="column">
        <div class="columns is-mobile has-text-centered">
          <div class="column">
            <i
              class="button is-primary is-rounded fas fa-dollar-sign fa-2x profession-icon"
              :class="active.name === 'Accounting/Finance' ? '' : 'is-outlined'"
              @click="selectProfession('Accounting/Finance')"
            />
            <p class="is-size-6 has-text-grey has-text-weight-bold">
              Accounting or Finance
            </p>
          </div>
          <div class="column">
            <i
              class="button is-primary is-rounded fas fa-handshake fa-sm profession-icon"
              :class="active.name === 'Business Development' ? '' : 'is-outlined'"
              @click="selectProfession('Business Development')"
            />
            <p class="is-size-6 has-text-grey has-text-weight-bold">
              Business Development
            </p>
          </div>
        </div>
      </div>
    </div>
    <section class="section no-pad-bottom">
      <div id="years-experience">
        <div class="field has-text-centered">
          <label
            class="label is-size-5"
            for="yearsExperience"
            :class="!professionIsSelected ? 'has-text-grey-light': ''"
          >Years of Experience</label>
          <div class="control is-expanded">
            <div class="select is-primary">
              <select
                id="years-experience-select"
                v-model="active.years_experience"
                name="yearsExperience"
                required
                :disabled="!professionIsSelected"
                @change="updateYearsExperience($event)"
              >
                <option>Less than 1 year</option>
                <option>1 - 5 Years</option>
                <option>6 - 10 Years</option>
                <option>11 - 20 Years</option>
                <option>20+ Years</option>
              </select>
            </div>
          </div>
        </div>
      </div>
    </section>
  </div>
</template>

<script>
export default {
  name: 'ProfessionCandidate',
  data () {
    return {
      active: {
        name: '',
        years_experience: null
      }
    };
  },
  computed: {
    professionIsSelected () {
      return this.active.name !== '';
    }
  },
  created () {
    if (this.$store.state.user.profile) {
      this.active.name = this.$store.state.user.profile.profession.name;
      this.active.years_experience = this.$store.state.user.profile.profession.years_experience;
    }
  },
  updated () {
    this.checkForm();
  },
  methods: {
    selectProfession (profession) {
      if (this.active.name === profession) {
        this.active.name = '';
        this.updateProfessionInProfile(this.active);
      } else {
        this.active.name = profession;
        this.updateProfessionInProfile(this.active);
      }
    },
    updateProfessionInProfile (profession) {
      this.$store.commit('EDIT_CANDIDATE_PROFESSION', profession);
    },
    updateYearsExperience ($event) {
      this.active.years_experience = $event.srcElement.value;
      this.updateProfessionInProfile(this.active);
    },
    checkForm () {
      this.$emit('checkForm');
    }
  }
};
</script>

<style lang="scss" scoped>
.profession-icon {
  line-height: 1.5;
  height: auto;
  padding-left: 0.5em;
  padding-right: 0.5em;
  min-width: 116px;
  border: 4px solid;
  margin-bottom: 1rem;
}

@media screen and (max-width: 768px) {
  .row:first-child {
    margin-bottom: 3rem;
  }
}

.step-description {
  margin-bottom: 2rem;
}

.button {
  min-height: 0;
  padding: none;
  width: 100px;
}

i {
  font-size: 3em !important;
}

#years-experience {
  max-width: 300px;
  margin: 0 auto;
}

#years-experience-select {
  width: 300px;
}

#profession-copy {
  margin-bottom: 3rem;
}
</style>
